import { BenefitCardAction } from '@leagueplatform/wallet-api';
import { isSaveCardAction } from '#utils/action-links.util.ts';

export const filterSaveCardAction = (actions: BenefitCardAction[]) =>
  actions.filter((action) => !isSaveCardAction(action));
